import React, { useState } from 'react';
import Preview from './Preview';
import { Link } from "react-router-dom"
import Speed from './Speed';
import { Button, Paper, TextField, CircularProgress } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Main from './Main';
import useStyles from "./styles"
import { useSelector } from 'react-redux';
import Lang from "../../Lang"

const Practice = () => {

  const classes = useStyles()
  const initialState = {
    text: "",
    userInput: '',
    symbols: 0,
    finished: false
  }

  const [state, setState] = useState(initialState)
  const [sec, setSec] = useState(0)
  const [started, setStarted] = useState(false)
  const [text, setText] = useState()
  const [news, setNews] = useState()
  const [index, setIndex] = useState(1)
  const [link, setLink] = useState()
  const [origen, setOrigen] = useState(null)
  const posts = useSelector((state) => state.posts)

  const onRestart = () => {
    setState(initialState)
    setStarted(false)
    setSec(0)
  }

  const onUserInputChange = (e) => {
    if (text) {
      const v = e.target.value;
      if (started === false) {
        setStarted(true)
      }

      setState({
        text: state.text,
        userInput: v,
        symbols: countCorrectSymbols(v),
        finished: state.finished
      })
      onFinish(v)
    }
  }

  const onFinish = (userInput) => {
    if (userInput === text) {
      clearInterval(state.interval)
      setIndex(index + 1)
      onRestart()
    }
  }

  const countCorrectSymbols = (userInput) => {
    const text = state.text.replace(' ', '');
    return userInput.replace(' ', '').split('').filter((s, i) => s === text[i]).length;
  }

  return (
    <div>
      <div className={classes.dir}>
        <Button component={Link} to="/" variant="outlined" className={classes.back_home_container}><ArrowBackIosIcon className={classes.back_home} /></Button>
        <h1 className={classes.title}><Lang props={"Practica"} /></h1>
        <Button component={Link} to="/Rss" variant="outlined" disabled={!posts.myPosts}>
          <Lang props={"Cartas"} />
        </Button>
      </div>
      <Paper className={classes.paper_practice} elevation={3}>
        {posts ? <>
          <Main text={text} setText={setText} onRestart={onRestart} index={index} setIndex={setIndex} setNews={setNews} link={link} setLink={setLink} origen={origen} setOrigen={setOrigen} />
          <Preview text={text} userInput={state.userInput} />
          <TextField className={classes.field} label={<Lang props={"Escribe aquí!"} />} variant="outlined"
            disabled={!origen}
            value={state.userInput}
            onChange={onUserInputChange}
            placeholder={text ? (
              "Go!"
            ) : (
              <Lang props={"Elige antes un texto!"} />
            )}
            readOnly={state.finished}
            news={news}
          />
        </>
          :
          <>
            <CircularProgress />
            <h2><Lang props={"Cargando..."} /></h2>
          </>
        }
      </Paper>
      <Speed sec={sec} symbols={state.symbols} />
    </div>
  );
}

export default Practice;
